import { render, staticRenderFns } from "./UserQualificationForm.vue?vue&type=template&id=4d87155e&scoped=true&"
import script from "./UserQualificationForm.vue?vue&type=script&lang=js&"
export * from "./UserQualificationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserQualificationForm.vue?vue&type=style&index=0&id=4d87155e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87155e",
  null
  
)

export default component.exports